import { MutationTree } from 'vuex';

import {
  CoursesStateI,
  CoursesResultI,
  CourseI,
} from './state';

export const mutations: MutationTree<CoursesStateI> = {
  setCoursesResult(state: CoursesStateI, payload: CoursesResultI) {
    state.coursesResult = payload;
  },
  setCourse(state: CoursesStateI, payload: CourseI) {
    state.course = payload;
  },
  setResponse(state: CoursesStateI, payload: string) {
    state.response += payload;
  },
  clearResponse(state: CoursesStateI) {
    state.response = '';
  },
};
